module.exports = __webpack_public_path__ + "img/github.a7fbe21c.svg";